var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.component,{ref:"item",tag:"component",attrs:{"showBack":_vm.showBack,"config":_vm.config},on:{"previous":_vm.previous,"next":_vm.next},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}})}
var staticRenderFns = []

export { render, staticRenderFns }